<ng-container *transloco="let t; prefix: scope">
  <div class="flex flex-col rounded-xl shadow">
    <div class="w-full rounded-t-xl py-10">
      <img class="h-24 mx-auto" src="assets/Lundify_Compliance_Logo.png" alt="Lundify Compliance" />
    </div>
    <div class="p-4">
      <h4 class="font-semibold inline-flex my-4">
        {{ t('dueAmlTitle') }}
      </h4>
      <p class="text-bl-grey-500">
        {{ t('dueAndAmlInfoText') }}
      </p>
    </div>
    <div class="flex justify-between items-center bg-bl-grey-50 p-8" *ngIf="state$ | async as state">
      <ng-container
        *ngTemplateOutlet="
          state.activeIntegration ? activeIntegrationTemplate : activateIntegrationTemplate;
          context: { $implicit: state }
        ">
      </ng-container>
    </div>
  </div>

  <ng-template #activeIntegrationTemplate>
    <bl-frontend-textbutton [text]="t('readMore')" (onclick)="openReadMoreLink()"></bl-frontend-textbutton>

    <div>
      <bl-frontend-button
        [text]="t('settings')"
        variant="secondary"
        (onclick)="showSettingsIntegrationDialog()"></bl-frontend-button>
      <bl-frontend-button
        class="pl-2"
        [text]="t('deactivate')"
        variant="primary-negative"
        (onclick)="showDeactivateIntegrationDialog()"></bl-frontend-button>
    </div>
  </ng-template>

  <ng-template #activateIntegrationTemplate let-state>
    <bl-frontend-textbutton [text]="t('readMore')" (onclick)="openReadMoreLink()"></bl-frontend-textbutton>

    <bl-frontend-button
      [pTooltip]="state.isAdminUser ? null : t('adminActivateTooltip')"
      [disabled]="!state.isAdminUser"
      [text]="t('activateIntegration')"
      variant="primary"
      (onclick)="showActivateIntegrationDialog()"></bl-frontend-button>
  </ng-template>
</ng-container>
